<h2 mat-dialog-title class="title-page-global text-center"> {{ gradeName }} - Khách hàng</h2>
<mat-dialog-content class="mat-typography">
    <div class="dialog-body">
        <div class="row" style="padding-left: 15px;">
            <p class="col-md-12 text-left m-0 mt-2 mb-2" style="font-size: 16px;">
                {{ lang.total }} {{ length }} khách hàng
            </p>
            <div class="col-md-12 row d-flex justify-content-center" style="padding-left: 30px;">
                <div class="col-md-12 pr-0 content-search">
                    <div style="cursor: pointer;">
                        <img src="assets/images/svg/search.svg" alt="">
                    </div>
                    <input #searchTenantOfGrade (focusout)="loadDataItems(searchTenantOfGrade.value)" (keydown)="searchListTenant($event,searchTenantOfGrade.value)" type="text" class="form-control" id="inputSearch" aria-describedby="emailHelp" placeholder="{{lang.placeholder_search}}">
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <table mat-table [dataSource]="listAccount" matSort class="table-el mt-0">
                <ng-container matColumnDef="stt">
                    <th mat-header-cell *matHeaderCellDef style="width: 5%;">STT</th>
                    <td mat-cell *matCellDef="let element;let i = index;">{{ i+1 }}</td>
                </ng-container>
                <ng-container matColumnDef="fullname">
                    <th mat-header-cell *matHeaderCellDef style="width: 25%;">Khách hàng</th>
                    <td mat-cell *matCellDef="let element" class="text-important-table">{{element.tenantFullname}}</td>
                </ng-container>
                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%;">Mã</th>
                    <td mat-cell *matCellDef="let element">{{element.tenantCode}}</td>
                </ng-container>
                <ng-container matColumnDef="domain">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%;">Tên miền</th>
                    <td mat-cell *matCellDef="let element"><a [href]="element.tenantUrl" target="_blank" rel="noopener noreferrer">{{element.tenantUrl}}</a></td>
                </ng-container>
                <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef style="width: 15%;">SĐT</th>
                    <td mat-cell *matCellDef="let element">{{element.tenantHotline}}</td>
                </ng-container>
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef style="width: 15%;">Email</th>
                    <td mat-cell *matCellDef="let element">{{element.tenantEmail}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns" style="line-height: 10px"></tr>
                <tr mat-row *matRowDef="let row; columns:displayedColumns" style="background: white"></tr>
            </table>
        </div>

    </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close mat-raised-button class="btn-close btn-close-applies-tenant custom-outline-button btn-add-global">
        {{lang.button_close}}
    </button>
</mat-dialog-actions>